// The company surface's mood.
//
// There used to be exactly one: a pale lavender ground with the organization's
// RED netti. That pair is now the BLOG's room, and the other company spaces get
// rooms of their own — built the same way, moved around the wheel — so you can
// tell from the corner of your eye whether you are reading a letter, a release,
// or a comparison. The construction lives in lib/company/theme; this file keeps
// the two names the rest of the app already imports.
//
// The backdrop publishes its hue, so the whole ink ladder warms toward whatever
// organism the room is wearing (the one-source-of-color law).

import { CO_THEMES } from "../../lib/company/theme";
import type { ColorState } from "../../lib/organism/color";

export * from "../../lib/company/theme";

/** the page ground — pale lavender (the Figma company spread). THE BLOG's room,
 *  and the fallback anything outside the company still wears (pricing, the
 *  landing's company act, the loading frame). */
export const CO_GROUND: string = CO_THEMES.blog.ground;

/** the organization's netti — deep warm red with a magenta fringe */
export const CO_RED: ColorState = CO_THEMES.blog.color;

// updates = the public, versioned changelog (v1.0, v1.1 …); blog = public
// letters; "inside innernet" = the founder-only daily product-dispatch archive;
// "reports" = the founders' readings of the whole company (kind 'report').
// BLOG FIRST: the ticker reads left to right and the leftmost word is where a
// visitor lands, so the front door of the company is its letters — not its
// changelog. (Updates led this list while it was empty, which was invisible;
// the moment it had releases in it, it took the front door.)
export const CO_TABS = [
  { key: "blog", label: "blog" },
  { key: "updates", label: "updates" },
  { key: "inside", label: "inside innernet" },
  { key: "reports", label: "reports" },
] as const;

export type CoTab = (typeof CO_TABS)[number]["key"];

/** the streams (kind) a tab shows. `updates`→releases, `blog`→letters,
 *  `inside`→the dispatch archive (founder-only via RLS). */
export const CO_TAB_KINDS: Record<CoTab, string[]> = {
  updates: ["update"],
  blog: ["blog"],
  inside: ["inside"],
  reports: ["report"],
};

/** the tabs only a founder stands in — the dispatch archive and the reports. */
const FOUNDER_TABS = new Set<string>(["inside", "reports"]);

/** the tabs a given viewer may see — inside and reports only for founders. */
export function companyTabs(founder: boolean): readonly { key: string; label: string }[] {
  return founder ? CO_TABS : CO_TABS.filter((t) => !FOUNDER_TABS.has(t.key));
}

export const CO_DEKS: Record<CoTab | "about" | "team", string> = {
  updates: "every release, newest first — what you can newly do, and what got quieter",
  blog: "news brought to you straight from innernet hq",
  inside: "how innernet is built, from the inside — the daily dispatch archive",
  reports: "the whole company, read from its own record: who came, who stayed, what we built. founders only.",
  about: "a persistent memory for the things you think, build, learn, and become. outside any one tool, kept by netti, and yours.",
  team: "four of us, small on purpose. the words about each person are their own.",
};
